<div class="nav-wrapper" [ngClass]="{ selected: selected() }" title="">
  <span class="icon">
    @if (icon()) {
    <mat-icon class="tab-icon">{{ icon() }}</mat-icon>
    } @else if (svgicon()) {
    <mat-icon [svgIcon]="svgicon()" class="tab-icon"></mat-icon>
    }
  </span>
  @if (! reduced()) {
  <span class="label">
    <span class="main">{{ label() }}</span>
    @if (subLabel()) {
    <span class="sub">{{ subLabel() }}</span>
    }
  </span>
  }
  <span class="selectbar"></span>
</div>
